import React, {useState} from "react";
import useEditableTableTextCell from "../../../hooks/useEditableTableTextCell";
import { Button, Control, Field, Select } from "@allxsmith/bestax-bulma";
import useInlineEditButton from "../../../hooks/useInlineEditButton";
import TrackingOptionsPicker from "../TrackingCategory/TrackingOptionsPicker";


export default function MovementTypeRow({type, dataFresh, handleChange, handleSave, index, onDelete, onTrackingOptionChange, trackingOptions}){
    const [editable, setEditable] = useState(false);
    const onChange = e => {
        handleChange(e,index)
    }
    const handleTrackingOptionChange = e => {
        onTrackingOptionChange(e, index)
    }
    const onSave = e => {
        handleSave(type);
        setEditable(false);
    }
    return (
        <tr>
            <td>
                {useEditableTableTextCell({
                    propName: "name",
                    value: type.name,
                    onSave,
                    onChange,
                    editable,
                    setEditable,
                    inlineEdit: true
                })}
            </td>
            <td>
                <Field className={"has-addons"}>
                    <Control>
                        <Select
                            name={"invoice_address"}
                            onChange={onChange}
                            value={type.invoice_address}
                            disabled={!editable}
                        >
                            <option key={0} value={"start"}>START</option>
                            <option key={1} value={"end"}>END</option>
                        </Select>
                    </Control>
                    {useInlineEditButton({show: true, onSave, setEditable, editable})}
                </Field>
            </td>
            <td>
                <TrackingOptionsPicker
                    name={"tracking_option"}
                    value={type.tracking_option}
                    inlineEdit={true}
                    onSave={onSave}
                    onChange={handleTrackingOptionChange}
                    editable={editable}
                    setEditable={setEditable}
                    disabled={!editable}
                    options={trackingOptions}
                    blank={true}
                />
            </td>
            <td>
                <Button
                    color={"danger"}
                    onClick={() => onDelete(type)}
                >
                    X
                </Button>
            </td>
        </tr>
    );


}